
export const environment = {
  production: true,
  // baseUrl: 'http://localhost:7028/api/v1/atmavaan',
  baseUrl: 'https://api.myairliftusa.com/api/v1/atmavaan',
  webPortaBaseUrl: 'https://api.myairliftusa.com/api/v1/app',
  filePath: 'https://app.atmavaan.com/uploads/',
  tarrifURL: 'https://api.myairliftusa.com/api/tariff/',
  airliftPath: 'https://api.myairliftusa.com/uploads/',
  airliftnet: 'https://api.airliftnet.com/',
  portalURL: 'https://app.airliftusa.com/',

  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebase: {
    apiKey: "AIzaSyBSwSVsM3AMxNtCeIwW-dxIUT6IQUjZOuk",
    authDomain: "airliftcrm.firebaseapp.com",
    projectId: "airliftcrm",
    storageBucket: "airliftcrm.appspot.com",
    messagingSenderId: "1057273331087",
    appId: "1:1057273331087:web:1e2c2003e538ec86859ffa",
    measurementId: "G-C5Y99KC6GG",
    vapidKey: "BC0vjm1LV5elZjmjPje_AeBZIuhu95paLpG9Z4aVa4VdJMuA44XfnCjWtLKTlttf-1rKa3WsFwbjPXLjjzTN99w"
  }
};


